<ion-fab vertical="bottom" horizontal="end" slot="fixed">
  <ion-fab-button (click)="showMenuActionSheet()" [activated]="closeActionSheetMenu" #fab [style.--background]="'pink'">
    <ion-icon name="menu"></ion-icon>
  </ion-fab-button>
  <ion-fab-list side="end"></ion-fab-list>
</ion-fab>